<template>
  <transition name="slide-fade">
    <div v-click-outside="clickOut" class="mobile-menu">
      <div class="menu-top">
        <div id="coins-mobile"></div>
        <button @click="menuClose" class="cross-btn">
          <svg
            width="23"
            height="21"
            viewBox="0 0 23 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.19922 3L19.6201 18"
              stroke="white"
              stroke-width="5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19.4219 3L3.00094 18"
              stroke="white"
              stroke-width="5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
      <div v-if="!isAuthenticated" @click="toLogin" class="mobile-item">
        <svg
          class="menu-icon"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H7"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14 15L19 10L14 5"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19 10H7"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Login
      </div>
      <div @click="toMyProfile" class="mobile-item">
        <svg
          class="menu-icon"
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5 0.92C5.65683 0.92 0.92 5.65683 0.92 11.5C0.92 14.1666 1.90651 16.6028 3.53447 18.4635C4.65532 16.0971 6.80508 14.0774 9.23029 13.2636C7.57547 12.4317 6.44 10.7184 6.44 8.74C6.44 5.94544 8.70544 3.68 11.5 3.68C14.2946 3.68 16.56 5.94544 16.56 8.74C16.56 10.7184 15.4245 12.4317 13.7697 13.2636C16.1949 14.0774 18.3447 16.0971 19.4655 18.4635C21.0935 16.6028 22.08 14.1666 22.08 11.5C22.08 5.65683 17.3432 0.92 11.5 0.92ZM18.7784 19.1787C17.515 16.1933 14.4678 13.8 11.5 13.8C8.53224 13.8 5.48504 16.1933 4.22165 19.1787C6.11813 20.9769 8.68024 22.08 11.5 22.08C14.3198 22.08 16.8819 20.9769 18.7784 19.1787ZM0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5ZM11.5 4.6C9.21354 4.6 7.36 6.45354 7.36 8.74C7.36 11.0265 9.21354 12.88 11.5 12.88C13.7865 12.88 15.64 11.0265 15.64 8.74C15.64 6.45354 13.7865 4.6 11.5 4.6Z"
            fill="white"
          />
        </svg>
        My Profile
      </div>
      <div class="js-accordion">
        <div class="mobile-item sub-menu js-accordion-title">
          <svg
            class="menu-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Settings
          <svg
            class="plus"
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 1.4052C20.1673 1.4052 25.5949 6.83275 25.5949 13.5001C25.5949 20.1674 20.1949 25.6225 13.5 25.6225C6.83265 25.6225 1.4051 20.195 1.4051 13.5276C1.4051 6.8603 6.83265 1.4052 13.5 1.4052ZM13.5 0C6.03368 0 0 6.03367 0 13.5C0 20.9663 6.03368 27 13.5 27C20.9663 27 27 20.9663 27 13.5C27 6.03367 20.9663 0 13.5 0Z"
              fill="white"
            />
            <path
              d="M7.46484 12.8115H19.5597V14.2166H7.46484V12.8115Z"
              fill="white"
            />
            <path
              d="M12.8125 7.46582H14.2176V19.5607H12.8125V7.46582Z"
              fill="white"
            />
          </svg>
          <svg
            class="minus"
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 1.4052C20.1673 1.4052 25.5949 6.83275 25.5949 13.5001C25.5949 20.1674 20.1949 25.6225 13.5 25.6225C6.83265 25.6225 1.4051 20.195 1.4051 13.5276C1.4051 6.8603 6.83265 1.4052 13.5 1.4052ZM13.5 0C6.03368 0 0 6.03367 0 13.5C0 20.9663 6.03368 27 13.5 27C20.9663 27 27 20.9663 27 13.5C27 6.03367 20.9663 0 13.5 0Z"
              fill="white"
            />
            <path
              d="M7.46484 12.8115H19.5597V14.2166H7.46484V12.8115Z"
              fill="white"
            />
          </svg>
        </div>
        <ul class="mobile-list js-accordion-content">
          <li class="mobile-list-item">
            <router-link to="/account-status" class="menu-link">
              Account Status
            </router-link>
          </li>
          <li class="mobile-list-item">
            <router-link to="/transaction-history" class="menu-link">
              Transactions
            </router-link>
          </li>
          <li class="mobile-list-item">
            <router-link to="/payment-system" class="menu-link">
              Payment System
              <template v-if="paymentData.connected">
                <svg
                  class="payment-icon"
                  width="18"
                  height="21"
                  viewBox="0 0 18 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 9C0 4.03734 4.03734 0 9 0C13.9627 0 18 4.03734 18 9C18 13.9627 13.9627 18 9 18C4.03734 18 0 13.9627 0 9ZM1.49995 8.99979C1.49995 13.1353 4.86443 16.4998 8.99995 16.4998C13.1355 16.4998 16.4999 13.1353 16.4999 8.99979C16.4999 4.86428 13.1355 1.49979 8.99995 1.49979C4.86443 1.49979 1.49995 4.86428 1.49995 8.99979Z"
                    fill="#78E28F"
                  />
                  <g filter="url(#filter0_d_6_1021)">
                    <path
                      d="M12.9957 6.5L7.5 12L5 9.5"
                      stroke="#78E28F"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_6_1021"
                      x="0"
                      y="5.5"
                      width="17.9922"
                      height="15.5"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_6_1021"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_6_1021"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
                <template v-if="paymentData.sepa_data">Sepa</template>
                <template v-else>PayPal</template>
              </template>
              <span class="connect-line" v-else>
                Connect Now
              </span>
            </router-link>
          </li>
          <li class="mobile-list-item">
            <button @click="goToCashout" class="menu-link">
              Cash Out Earnings
            </button>
          </li>
          <li class="mobile-list-item">
            <button @click="goToChangePass" class="menu-link">
              Password
            </button>
          </li>
        </ul>
      </div>
      <div class="js-accordion">
        <div class="mobile-item sub-menu js-accordion-title">
          <svg
            class="menu-icon"
            width="23"
            height="24"
            viewBox="0 0 23 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.4428 23C17.2749 23 22.0028 18.0751 22.0028 12C22.0028 5.92487 17.2749 1 11.4428 1C5.61069 1 0.882812 5.92487 0.882812 12C0.882812 18.0751 5.61069 23 11.4428 23Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.4453 16.4001V12"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.4453 7.60156H11.454"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          More Info
          <svg
            class="plus"
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 1.4052C20.1673 1.4052 25.5949 6.83275 25.5949 13.5001C25.5949 20.1674 20.1949 25.6225 13.5 25.6225C6.83265 25.6225 1.4051 20.195 1.4051 13.5276C1.4051 6.8603 6.83265 1.4052 13.5 1.4052ZM13.5 0C6.03368 0 0 6.03367 0 13.5C0 20.9663 6.03368 27 13.5 27C20.9663 27 27 20.9663 27 13.5C27 6.03367 20.9663 0 13.5 0Z"
              fill="white"
            />
            <path
              d="M7.46484 12.8115H19.5597V14.2166H7.46484V12.8115Z"
              fill="white"
            />
            <path
              d="M12.8125 7.46582H14.2176V19.5607H12.8125V7.46582Z"
              fill="white"
            />
          </svg>
          <svg
            class="minus"
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 1.4052C20.1673 1.4052 25.5949 6.83275 25.5949 13.5001C25.5949 20.1674 20.1949 25.6225 13.5 25.6225C6.83265 25.6225 1.4051 20.195 1.4051 13.5276C1.4051 6.8603 6.83265 1.4052 13.5 1.4052ZM13.5 0C6.03368 0 0 6.03367 0 13.5C0 20.9663 6.03368 27 13.5 27C20.9663 27 27 20.9663 27 13.5C27 6.03367 20.9663 0 13.5 0Z"
              fill="white"
            />
            <path
              d="M7.46484 12.8115H19.5597V14.2166H7.46484V12.8115Z"
              fill="white"
            />
          </svg>
        </div>
        <ul class="mobile-list js-accordion-content">
          <li class="mobile-list-item">
            <router-link to="/faq" class="menu-link">FAQ</router-link>
          </li>
          <li class="mobile-list-item">
            <a
              class="menu-link"
              href="mailto:info@anymecam.com?subject=Contact%20Us"
            >
              Contact Us
            </a>
          </li>
          <li class="mobile-list-item">
            <router-link to="/terms" class="menu-link">
              Terms & Conditions
            </router-link>
          </li>
          <li class="mobile-list-item">
            <router-link to="/privacy-policy" class="menu-link">
              Privacy Policy
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if="isAuthenticated" @click="toLogout" class="mobile-item">
        <svg
          class="menu-icon"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H7"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14 15L19 10L14 5"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19 10H7"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Logout
      </div>
    </div>
  </transition>
</template>

<script>
import ClickOutside from "vue-click-outside";

import { mapGetters } from "vuex";

export default {
  directives: {
    ClickOutside,
  },

  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      readyToClose: false,
    };
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters(["paymentData"]),
  },

  methods: {
    menuClose() {
      this.$emit("menuClose");
    },

    clickOut() {
      if (this.readyToClose) this.menuClose();
    },

    toMyProfile() {
      if (this.isAuthenticated)
        this.$router.push({
          name: "Profile",
          query: {
            tab: "albums",
            type: "private",
          },
        });
      else this.$emit("goToLogin");

      this.$emit("menuClose");
    },

    toLogin() {
      this.$emit("goToLogin");
      this.$emit("menuClose");
    },

    toLogout() {
      this.$emit("goToLogout");
      this.$emit("menuClose");
    },

    goToCashout() {
      if (this.paymentData.connected) {
        this.$router.push({ name: "Cashout" });

        return;
      }

      const payload = {
        active: true,
        type: "warning",
        text: "Connect payment system first.",
      };

      this.$store.dispatch("setToast", payload);

      this.$router.push({ name: "Payment" });
    },

    goToChangePass() {
      this.$emit("goToChangePass");
    },
  },

  mounted() {
    this.$store.dispatch("getPaymentData");
  },

  watch: {
    "$route.path"() {
      this.$emit("menuClose");
    },

    status(value) {
      setTimeout(() => {
        this.readyToClose = value;
      }, 0);
    },
  },
};
</script>

<style scoped>
.mobile-menu {
  position: fixed;
  width: 375px;
  height: 100vh;
  top: 0;
  right: 0;
  background: linear-gradient(180.14deg, #092974 0.11%, #1c23c3 25.96%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  box-shadow: 0 4px 10px rgba(44, 145, 179, 0.3);
  z-index: 9999;
  overflow-y: auto;
}

@media (max-width: 767px) {
  .mobile-menu {
    width: 100%;
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(375px);
  opacity: 0;
}

.menu-top {
  padding: 0 30px;
  width: 100%;
  height: 73px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #9ba7ab;
}

.cross-btn {
  background: none;
  border: none;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.mobile-item {
  padding: 0 20px;
  font-family: "SF Pro Display";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #fff;
  height: 51px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #9ba7ab;
  text-decoration: none;
  cursor: pointer;
}

.sub-menu .plus,
.sub-menu .minus {
  margin-left: auto;
}

.is-open .mobile-item {
  background: #020912;
}

.mobile-list {
  display: none;
  background: linear-gradient(360deg, #000 -74.05%, #06247a 100%);
}

.minus {
  display: none;
}

.is-open .minus {
  display: initial;
}

.is-open .plus {
  display: none;
}

.mobile-list-item:not(:last-child) {
  border-bottom: 1px solid #9ba7ab;
}

.menu-link {
  padding: 0 45px;
  display: flex;
  align-items: center;
  line-height: 49px;
  color: #fff;
  text-decoration: none;
  width: 100%;
  height: 51px;
  background: none;
  border: none;
  cursor: pointer;
}

.menu-icon {
  margin-right: 7px;
  width: 26px;
}

.payment-icon {
  margin: 0 10px;
}

.connect-line {
  margin-left: 10px;
  padding: 6px 0 3px;
  border-bottom: 1px solid #fff;
  line-height: 1;
}

_::-webkit-full-page-media,
_:future,
:root .mobile-menu {
  height: calc(100% - env(safe-area-inset-bottom));
}
</style>
